import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class UnauthenticatedNav extends Component {

  render() {
    return (
      <nav className="unauthenticated">
        <Link
          className="cta"
          title="Log In"
          to="/log-in"
        >
          Log In
        </Link>
        <Link
          className="cta invert"
          title="Sign Up"
          to="/sign-up"
        >
          Sign Up
        </Link>
      </nav>
    );
  }
}

export default UnauthenticatedNav;



// WEBPACK FOOTER //
// ./src/components/Global/UnauthenticatedNav.js